import  React ,{useState,useEffect}from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import './Imagelist.css'
import Cookies from "universal-cookie";
import swal from 'sweetalert'

import $ from 'jquery';
import UrlImageDownloader from 'react-url-image-downloader'
import ApiSetting from "../../../../../../Settings/ApiSettings.json";
import axios from 'axios';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';

const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

export default function Imagelist({object,Access,Resources,setResources,section_id,stage_transaction_type_id}) {
 const [url,setUrl]=React.useState('')
 const [disableCache,setdisableCache]=React.useState(false)
//  const [Resources,setResources]=useState([])
 const [checkEdit,setCheckEdit]=useState(false)
 const [checkDelete,setCheckDelete]=useState(false)
 const [itemForUpdate,setItemForUpdate]=useState({})
 const [File,setFile]=useState(null)


    var downloadImage = React.useCallback(function (e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        // if (!imageUrl.length) {
        //     console.log('Please add an image url');
        //     return;
        // }
        var fetchUrl = "".concat(e.target.href).concat(disableCache ? "?dummy=".concat(Math.floor(Date.now())) : '');
        fetch(fetchUrl, {
            method: 'GET',
            headers: {}
        })
            .then(function (response) {
            response.arrayBuffer().then(function (buffer) {
                var url = window.URL.createObjectURL(new Blob([buffer]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', e.target.href.substr(e.target.href.lastIndexOf('/') + 1));
                document.body.appendChild(link);
                link.click();
            });
        })
            .catch(function (error) {
            console.log(error);
            return error;
        });
    }, [disableCache]);

   
  

    const checkAccessPrivilegesCanEdit=()=>{
      let check=false;
      // console.log('AccesDDDDDDDDDDDDDDDD')

      if(Access?.length>0){
        console.log('AccesDDDDDDDDDDDDDDDD',Access)

      Access?.map((data)=>{
        // console.log('AccesDDDDDDDDDDDDDDDD')

         if(data==3){
          //  check=true;
          setCheckEdit(true)
         }
      })
    }
      // return check;
    }
    const checkAccessPrivilegesCanDelete=()=>{
      let check=false;

      if(Access?.length>0){

      Access?.map((data)=>{
        // console.log('AccesDDDDDDDDDDDDDDDD')

         if(data==4){
          //  check=true;
          setCheckDelete(true)
         }
      })
    }
      // return check;
    }

    useEffect(()=>{

      if(Access?.length>0){
        checkAccessPrivilegesCanEdit()
        checkAccessPrivilegesCanDelete()
      }
        
    },[Access])

    const updateImage=async()=>{

    let data=null;
    let formData=new FormData();
       formData.append('file',File);
       formData.append('image_id',itemForUpdate?.id)
       formData.append('income_report_tax_id',itemForUpdate?.incom_tax_reports_id);
       formData.append('section_id',section_id)
       formData.append('stage_transaction_type_id',stage_transaction_type_id)
       formData.append('user_id',cookies.get('user_id'))
       formData.append('role_id',cookies.get('role_id')+1)

      try{
          data=await axios({
            method:'post',
            url:ApiSetting.apiUrl+'/income_tax_report/image_for_income_tax_report/update',
            data:formData,
            headers:{
              "Content-Type": "multipart/form-data",
              'Accept':'application/json',
              "X-localization": language,
            }
          })
          if(data){
              if(data?.data?.status==200){
                  setResources(data?.data?.data)
                  setFile(null)
                  setItemForUpdate({})
                  swal("نجحت العملية!", `${data?.data?.message}`, "success");
              }else{
                swal(" فشلت العملية!", `${data?.data?.message}`, "warning");
              }
          }
      }catch(err){
        swal(" فشلت العملية!", `${err?.message}`, "error");
      }
  
    }
    useEffect(()=>{
      if(itemForUpdate && File){
        updateImage()
      }
    },[
      itemForUpdate,
      File,
    ])


    const deleteImage=async(resourceData)=>{

      swal({
        title: "هل انت متئكد?",
        text: "بمجرد الحذف لن يعد باامكانك استرجاع العنصر ",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then(async(willDelete) => {
        if (willDelete) {
          let data=null;
            try{
                data=await axios({
                  method:'delete',
                  url:ApiSetting.apiUrl+'/income_tax_report/image_for_income_tax_report/'+resourceData?.id,
                  params:{
                    income_report_tax_id:resourceData?.incom_tax_reports_id,
                    user_id:cookies.get('user_id'),
                    role_id:cookies.get('role_id')+1,
                    section_id:section_id,
                    stage_transaction_type_id:stage_transaction_type_id
                  },
                  headers:{
                    'Content-Type':'application/json',
                    'Accept':'application/json',
                    "X-localization": language,
                  }
                })
                if(data){
                    if(data?.data?.status==200){
                      swal(`${data?.data?.message}`, {
                        icon: "success",
                      });
                      setResources(data?.data?.data)
                        // swal("نجحت العملية!", `${data?.data?.message}`, "success");
                    }else{
                      swal(" فشلت العملية!", `${data?.data?.message}`, "warning");
                    }
                }
            }catch(err){
              swal(" فشلت العملية!", `${err?.message}`, "error");
            }
  
       
      }
    });
    }




  return (
    <ImageList sx={{ width: '100%', height: 'auto', }}  cols={4} >
      {Resources?.map((item) => (
        <ImageListItem key={item.id+"_"} style={{position:'relative'}}>
          <div style={{position:'relative',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
            
            <img
              src={item.file_type=="image"?`${ApiSetting.ResourcesUrl}/images/${item.image_name}?w=248&fit=crop&auto=format`:"https://play-lh.googleusercontent.com/BkRfMfIRPR9hUnmIYGDgHHKjow-g18-ouP6B2ko__VnyUHSi1spcc78UtZ4sVUtBH4g"}
              srcSet={`${ApiSetting.ResourcesUrl}/images/${item.image_name}?w=248&fit=crop&auto=format&dpr=2 2x`}
              alt={item.image_for_what}
              loading="lazy"
              id='imageItm'
            />
            <div className='showbox'>
               {
                checkEdit?
                  <p className='IMG'  title="edit"
                    onClick={()=>{
                       if(item?.file_type=='image')
                       document.getElementById('Images3').accept='image/png,image/jpg,image/jpeg'
                       else
                       document.getElementById('Images3').accept='application/pdf'
                       document.getElementById('Images3').click()


                       setItemForUpdate(item)

                    }}
                  >
                    <AddAPhotoIcon color="red"/>
                  </p> 
                :null
                }
                {
                checkDelete?
                    <p className='IMG'  title="view" 
                      onClick={()=>deleteImage(item)}
                    >
                        <i class="bi bi-trash-fill" style={{color:'red'}}></i>
                    </p>
                 :null
                }
                <a className='IMG' href={item.file_type=="image"?`${ApiSetting.ResourcesUrl}/images/${item.image_name}?w=248&fit=crop&auto=format`:`${ApiSetting.ResourcesUrl}/pdfs/${item.pdf_name}`} target="_blank" title="view">
                   <i className="bi bi-eye-fill" ></i>
                </a> 
                <a className='IMG' href={item.file_type=="image"?`${ApiSetting.ResourcesUrl}/images/${item.image_name}?w=248&fit=crop&auto=format`:`${ApiSetting.ResourcesUrl}/pdfs/${item.pdf_name}`} title="download"  onClick={()=>{
                  downloadImage(`${ApiSetting.ResourcesUrl}/pdfs/${item.pdf_name}`)
                }} >
                   <i className="bi bi-arrow-down-circle-fill"></i>
                </a>
                
            </div>
          </div>
          <ImageListItemBar
            title={item.file_type=='image'?item.image_for_what:item.pdf_name}
            subtitle={<span>by: {item.file_type}</span>}
            position="below"
          />
        </ImageListItem>
      ))}
       <input
        type="file"
        id="Images3"
        className="images3 d-none"
        name="images3"
        // accept={it.mem?filesObject.mem:null}
        onChange={(e) => {
          
          // updateImage(e.target.files[0])
          setFile(e.target.files[0])

        }}
        />
    </ImageList>
  );
}


